import { AdminMembersReportPageParams } from "@/admin/insights/member-reports/AdminMembersReportPage"
import { AdminMembersReportProfileFieldsTableExportCSVButtonMutation } from "@/admin/insights/member-reports/tabs/overview/__generated__/AdminMembersReportProfileFieldsTableExportCSVButtonMutation.graphql"
import Relay from "@/relay/relayUtils"
import { displayErrorToast } from "@components/toast/ToastProvider"
import { DiscoButton } from "@disco-ui"
import { useQueryParamState } from "@disco-ui/tabs/DiscoQueryParamTabs"
import { useState } from "react"
import { graphql } from "relay-runtime"

function AdminMembersProfileFieldsTableExportCSVButton() {
  const [queryParams] = useQueryParamState<AdminMembersReportPageParams>()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const createCSVMutation =
    Relay.useAsyncMutation<AdminMembersReportProfileFieldsTableExportCSVButtonMutation>(
      graphql`
        mutation AdminMembersReportProfileFieldsTableExportCSVButtonMutation(
          $input: CreateAdminMemberReportProfileFieldsCSVDataInput!
        ) {
          response: CreateAdminMemberReportProfileFieldsCSVData(input: $input) {
            downloadCSVLink
            errors {
              field
              message
            }
          }
        }
      `
    )

  return (
    <DiscoButton
      color={"grey"}
      variant={"outlined"}
      onClick={handleExportCSVClick}
      shouldDisplaySpinner={isSubmitting}
    >
      {"Export CSV"}
    </DiscoButton>
  )

  async function handleExportCSVClick() {
    // Call mutation to handle this on the backend, return string
    try {
      setIsSubmitting(true)
      const { response: mutationResponse } = await commitMutation()

      if (mutationResponse.downloadCSVLink) {
        window.location.href = mutationResponse.downloadCSVLink
      }
    } catch (error) {
      displayErrorToast(error)
    }
    setIsSubmitting(false)
  }

  function commitMutation() {
    return createCSVMutation({
      input: { organizationMembershipId: queryParams.om! },
    })
  }
}

export default AdminMembersProfileFieldsTableExportCSVButton
